import { UserOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Form, Input, Radio, Row, message } from 'antd';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { themTaiKhoan } from '../../services/nguoidung';
import { responseStatus } from '../../constants';
import { toast } from 'react-toastify';
import { validateMessages } from '../../helpers/common';


const ThemTaiKhoanBox = ({ idNhanVien, show, onClose, onSubmit }: { idNhanVien: number, show: boolean, onClose: () => void, onSubmit: () => void }) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onFinish = async (values: any) => {
        setIsLoading(true);
        var response: any = await themTaiKhoan({
            idNhanVien: idNhanVien,
            ...values
        });

        if (response.trangThai === responseStatus.thanhCong) {
            toast.success('Thêm mới tài khoản thành công');
        } else {
            toast.error(response.thongBao);
        }

        setIsLoading(false);
        onClose();
        onSubmit();
    };

    useEffect(() => {
        
    }, []);
    return (
        <ModalTextForm show={show} hideFooter
            title="Thêm mới tài khoản"
            handleClose={() => {
                if (!isLoading) {
                    onClose();
                }
            }}
            handleSave={() => { setIsLoading(true) }}>
            <Row>
                <Col>
                    <Form layout="vertical" onFinish={onFinish} validateMessages={validateMessages}>
                        <Form.Item name="tenDangNhap" label="Tài khoản"
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    min: 4,
                                },
                                {
                                    max: 50,
                                },
                                {
                                    pattern: /^[a-zA-Z0-9._]+$/,
                                    message: "Tài khoản không chứa kí tự đặc biệt"
                                }
                            ]}>
                            <Input
                                prefix={<UserOutlined rev="" className="site-form-item-icon" />}
                                placeholder="Tài khoản"
                            />
                        </Form.Item>
                        <Form.Item name="matKhau" label="Mật khẩu"
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    min: 6,
                                },
                                {
                                    max: 20,
                                },
                                {
                                    pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,20}$/,
                                    message: "Mật khẩu bao gồm ít nhật một kí tự thường, chữ số và ký tự đặc biệt"
                                }
                            ]} hasFeedback>
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="matKhau2"
                            label="Nhập lại mật khẩu"
                            hasFeedback
                            dependencies={['matkhau']}
                            rules={[
                                {
                                    required: true,
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('matKhau') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Mật khẩu không khớp'));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isLoading} icon=<SaveOutlined rev="" />>
                                Lưu
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </ModalTextForm>
    );
};

export default ThemTaiKhoanBox;
